//import React from 'react'
//import { Box, Typography, Container, Grid, makeStyles } from '@material-ui/core'
//import TeamCard from 'src/component/TeamCard'

//const TeamMap = [
//  {
//    img1: 'images/avatarframe.png',
//    img2: 'images/vector1.png',
//    text1: 'John Palmer',
//  },
//  {
//    img1: 'images/avatarframe.png',
//    img2: 'images/vector1.png',
//    text1: 'John Palmer',
//  },
//  {
//    img1: 'images/avatarframe.png',
//    img2: 'images/vector1.png',
//    text1: 'John Palmer',
//  },
//  {
//    img1: 'images/avatarframe.png',
//    img2: 'images/vector1.png',
//    text1: 'John Palmer',
//  },
//]

//const useStyles = makeStyles((theme) => ({
//  mainbox: {
//    width: '100%',
//    padding: '130px 0 160px',
//    //backgroundImage: 'url(./images/mintbg.png)',
//    //backgroundSize: 'cover',
//    //backgroundPosition: 'center',
//    //backgroundRepeat: 'no-repeat',
//  },
//  textbox: {
//    //padding: '70px',

//    '& h2': {
//      fontSize: '70px',
//      fontWeight: '400',
//      color: '#fff',
//      [theme.breakpoints.down('sm')]: {
//        fontSize: '50px',
//      },
//      [theme.breakpoints.down('xs')]: {
//        fontSize: '30px',
//      },
//    },
//  },
//  head: {
//    marginTop: '-160px',
//    position: 'relative',
//    zIndex: '1',
//  },
//}))

//function HelpCenter() {
//  const classes = useStyles()
//  return (
//    <Box>
//      <Box className={classes.mainbox}>
//        <Box className={classes.head}>
//          {/*<Grid container>*/}
//          {/*<Grid item lg={6} md={6} sm={12} xs={12}>*/}
//          <Box
//            display="flex"
//            justifyContent="space-between"
//            alignItems="center"
//          >
//            <Box>
//              <img
//                src="images/warprev.png"
//                alt=""
//                width="100%"
//                style={{ width: '100%', maxWidth: '600px' }}
//              />
//            </Box>
//            {/*</Grid>*/}
//            {/*<Grid item lg={6} md={6} sm={12} xs={12}>*/}
//            <Box>
//              <img
//                src="images/warnext.png"
//                alt=""
//                width="100%"
//                style={{ width: '100%', maxWidth: '600px' }}
//              />
//            </Box>
//          </Box>

//          {/*</Grid>*/}
//          {/*</Grid>*/}
//        </Box>
//        <Box
//          mt={5}
//          mb={7}
//          className={classes.textbox}
//          display="flex"
//          justifyContent="center"
//          alignItems="center"
//        >
//          <Box>
//            <Typography variant="h2">TEAM</Typography>
//          </Box>
//        </Box>
//        <Container>
//          <Box pt={10}>
//            <Box>
//              <Grid container spacing={3}>
//                {TeamMap.map((data, i) => {
//                  return (
//                    <Grid item xs={12} sm={6} md={3} lg={3} key={i}>
//                      <TeamCard data={data} index={i} />
//                    </Grid>
//                  )
//                })}
//              </Grid>
//            </Box>
//          </Box>
//        </Container>
//      </Box>
//    </Box>
//  )
//}

//export default HelpCenter

import React from 'react'
import { Box, Typography, Container, Grid, makeStyles } from '@material-ui/core'
import TeamCard from 'src/component/TeamCard'

const TeamMap = [
  {
    img1: 'images/avatarframe.png',
    img2: 'images/vector1.png',
    text1: 'John Palmer',
  },
  {
    img1: 'images/avatarframe.png',
    img2: 'images/vector1.png',
    text1: 'John Palmer',
  },
  {
    img1: 'images/avatarframe.png',
    img2: 'images/vector1.png',
    text1: 'John Palmer',
  },
  {
    img1: 'images/avatarframe.png',
    img2: 'images/vector1.png',
    text1: 'John Palmer',
  },
]

const useStyles = makeStyles((theme) => ({
  mainbox: {
    width: '100%',
    position: 'relative',
    padding: '130px 0 200px',
    //backgroundImage: 'url(./images/mintbg.png)',
    //backgroundSize: 'cover',
    //backgroundPosition: 'center',
    //backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('xs')]: {
      padding: '60px 0 90px',
    },
  },
  textbox: {
    //padding: '70px',

    '& h2': {
      fontSize: '70px',
      fontWeight: '400',
      color: '#fff',
      [theme.breakpoints.down('sm')]: {
        fontSize: '50px',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '30px',
      },
    },
    '@media(max-width:768px)': {
      marginTop: '0px',
      marginBottom: '20px',
    },
    '@media(max-width:375px)': {
      marginTop: '0px',
      marginBottom: '0px',
    },
  },
  head: {
    // marginTop: '-160px',
    // position: 'relative',
    // zIndex: '1',
  },
  topleft: {
    position: 'absolute',
    top: '-36px',
    left: '0px',
    width: '100%',
    maxWidth: '600px',
    zIndex: '1',
    [theme.breakpoints.down('md')]: {
      top: '-17px',
      width: '25%',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  topright: {
    position: 'absolute',
    top: '-36px',
    right: '0px',
    width: '100%',
    maxWidth: '600px',
    zIndex: '1',
    [theme.breakpoints.down('md')]: {
      top: '-17px',
      width: '25%',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  botomleft: {
    position: 'absolute',
    bottom: '-36px',
    left: '0px',
    width: '100%',
    maxWidth: '600px',
    [theme.breakpoints.down('md')]: {
      bottom: '-17px',
      width: '25%',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  botomright: {
    position: 'absolute',
    bottom: '-36px',
    right: '0px',
    width: '100%',
    maxWidth: '600px',
    [theme.breakpoints.down('md')]: {
      bottom: '-17px',
      width: '25%',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))

function HelpCenter() {
  const classes = useStyles()
  return (
    <Box>
      <Box className={classes.mainbox}>
        <img
          src="images/topleftarrow.png"
          alt="Top Left Arrow"
          className={classes.topleft}
        />
        <img
          src="images/toprightarrow.png"
          alt="Top Right Arrow"
          className={classes.topright}
        />
        <Box className={classes.head}>
          {/*<Grid container>*/}
          {/*<Grid item lg={6} md={6} sm={12} xs={12}>*/}

          {/*</Grid>*/}
          {/*</Grid>*/}
        </Box>
        <Box
          mt={5}
          mb={7}
          className={classes.textbox}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Box>
            <Typography variant="h2">TEAM</Typography>
          </Box>
        </Box>
        <Container>
          <Box pt={10}>
            <Box>
              <Grid container spacing={3}>
                {TeamMap.map((data, i) => {
                  return (
                    <Grid item xs={12} sm={6} md={3} lg={3} key={i}>
                      <TeamCard data={data} index={i} />
                    </Grid>
                  )
                })}
              </Grid>
            </Box>
          </Box>
        </Container>
        <img
          src="images/bottomleftarrow.png"
          alt="Bottom Left Arrow"
          className={classes.botomleft}
        />
        <img
          src="images/bottomrightarrow.png"
          alt="Bottom Right Arrow"
          className={classes.botomright}
        />
      </Box>
    </Box>
  )
}

export default HelpCenter
